<template>
    <div>

        <categoryBar ref="categoryBar" @changeCategory="onChangeCategory"/>

        <div class="centered" style="width: 92.11vw; margin-top: 14px;">
            <adModule version="4"/>
        </div>

        <div class="atlasList">
            <!-- 单个样式 -->
            <!--        <div class="dataListNull" v-show="dataList.length===0">暂无数据</div>-->
            <div class="atlasSingular roundBorder8 hiddenOverflow"
                 v-for="dataItem in dataList" :key="dataItem.id" @click="viewItem(dataItem)">
                <div class="atlasImage roundBorder8">
                    <img class="fullSpace" :src="dataItem.coverImg">
                    <div class="viewArea">
                        <div class="paddingH8">
                            <i class="icon whiteViewIcon alignM" style="width: 14px; height: 14px;"></i>
                            {{dataItem.pv + dataItem.shamPv}}人查看
                        </div>
                    </div>
                </div>
                <div class="atlasCharacter bgFAFAFA">
                    <div class="atlasTitle font14r bold color333">{{dataItem.title}}</div>
                    <div class="atlasNumber clearfix">
                        <div class="atlasUser floatL w50p" style="line-height: 24px;">
                            <div class="atlasUserImage marginR4">
                                <img class="size24 circle" :src="dataItem.userImg">
                            </div>
                            <div class="atlasUserName font12r" style="color: hsla(219, 9%, 39%, 1)">{{dataItem.userName}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 暂时搜不到内容，搜搜其他内容吧 -->
        <div class="alignC paddingT20" v-show="status === 'ready' && dataList.length < 1">
            <img src="notice/no_content.png" width="206" height="143" alt="暂时没有任何内容"/>
        </div>

        <div class="alignC paddingT20" v-show="status === 'loading'">
            <i class="spinner-loader"></i>
        </div>

        <div class="font12r grey60 alignCenter" style="padding: 26px 0 9px;"
             v-show="status=='ready' && pagination.current == pagination.totalPage"
             :data-current="pagination.current" :data-total="pagination.totalPage || 0">
            -没有更多啦-
        </div>
    </div>
</template>
<script>

import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// modules
import categoryBar from './envCreationComp/categoryBar';
import adModule from '@/components/ad/bannerModule4'

// data
import bizTypeEnum from '@data/bizTypeEnum';
import adTypeEnum from '@/components/ad/adTypeEnum';
import externalApp from '@data/externalApp';

// util
import appHelper from '@util/appHelper';

const config = {
    apiConfig : {
        list : {
            url : 'portal/atlas/list',
            dataPath : 'data.rows',
            totalPath : 'data.total',
            totalPagePath : 'data.totalPage'
        }
    }
};

export default {

    extends : shixunPagePart,
    components: { categoryBar, adModule },
    data() {
        return {
            adTypeEnum : adTypeEnum,
            apiConfig: config.apiConfig,
            enableDataList : true,
            autoLoadDataList : true,
            // scrollToLoadNextPage : true
        }
    },
    methods : {
        viewItem(dataItem) {
            let url = externalApp.oldShixun.baseUrl + 'html/atlas/detail.html?id=' + dataItem.id;
            appHelper.redirect(url);
        },
        onChangeCategory(event) {

            var categoryData = event.data;

            var params = this.apiConfig.list.params || {};
            if (categoryData)
            {

                params.categoryList = categoryData.id;
            }
            else
            {
                delete params.categoryList;
            }

            this.apiConfig.list.params = params;
            this.reloadDataList();
        }
    },
    mounted() {
    }
}
</script>
<style scoped lang="scss">
.atlasList {
    .dataListNull {
        width: 300px;
        height: 300px;
        color: red;
        text-align: center;
    }

    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    background: #ffffff;

    .atlasSingular {
        width: 43.833vw;
        height: 56.53vw;
        margin: 14px 0 0 4.444vw;
        background-color: hsla(0, 0%, 97%, 1);

        .atlasImage {

            position: relative;
            width: 43.833vw;
            height: 33vw;

            .viewArea {

                position: absolute;
                z-index: 1;
                width: 100%;
                height: 29px;
                left: 0;
                bottom: 0;

                line-height: 29px;
                background: linear-gradient(180deg, rgba(44, 44, 44, 0) 0%, rgba(0, 0, 0, .69) 100%);
                /*opacity: 0.69;*/

                font-size: 12px;
                color: white;
            }
        }

        .atlasCharacter {
            padding: 0 9px;

            .atlasTitle {
                padding-top: 2.778vw;
                overflow: hidden;
                text-overflow: ellipsis;
                /*white-space: nowrap;*/
                line-height: 18px;
                height: 36px;
                margin-bottom: 16px;
            }

            .atlasNumber {

                .atlasUser {
                    display: flex;
                    margin-top: -0.833vw;
                    line-height: 16px;
                }
            }
        }
    }
}
</style>
